import { render } from "./elem-richtext.vue?vue&type=template&id=4f20e1a8&ts=true"
import script from "./elem-richtext.vue?vue&type=script&lang=ts"
export * from "./elem-richtext.vue?vue&type=script&lang=ts"

import "./elem-richtext.vue?vue&type=style&index=0&id=4f20e1a8&lang=css"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__